import React from "react";
import "./footer.css";
import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaXTwitter,
  FaLinkedinIn,
  FaEnvelope,
  FaAward,
  FaGlobe,
} from "react-icons/fa6";
import lawvs from "../assets/images/logo/lawvs.png";
import advocateMatrimony from "../assets/images/logo/matrimony.png";
import icsaj from "../assets/images/logo/icsaj.png";
import vishnu from "../assets/images/logo/advvishnu.png";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="awards-footer">
      <div className="footer-container">
        <h6 className="footer-title">
          <FaAward /> Our Initiatives & Platforms
        </h6>
        {/* PLATFORM LINKS */}
        <div className="footer-logos">
          <Link
            to="https://lawvs.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={lawvs} alt="LAWVS" />
          </Link>

          <Link
            to="https://advocatematrimony.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={advocateMatrimony} alt="Advocate Matrimony" />
          </Link>

          <Link
            to="https://icsaj.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={icsaj} alt="ICSAJ" />
          </Link>

          <Link to="https://advocatevishnu.com/" target="_blank">
            <img src={vishnu} alt="ADV. Vishnu" />
          </Link>
        </div>
        {/* QUICK LINKS */}
        <div className="footer-links">
          <Link to="/">Home</Link>
          <Link to="/vote">Vote</Link>
          <Link to="/candidates">Candidates</Link>
          <Link to="/help">Help & Support</Link>
          <Link to="/contact-us">ContactUs</Link>
        </div>
        {/* SOCIAL ICONS */}
        <div className="footer-social">
          <Link to="https://www.facebook.com/LawvsF" target="_blank">
            <FaFacebookF />
          </Link>
          <Link to="https://www.instagram.com/lawvslegal" target="_blank">
            <FaInstagram />
          </Link>
          <Link to="https://x.com/LawvsF" target="_blank">
            <FaXTwitter />
          </Link>
          <Link to="https://www.youtube.com/@LAWVSLEGAL" target="_blank">
            <FaYoutube />
          </Link>
          <Link to="mailto:awards@lawvs.com" target="_blank">
            <FaEnvelope />
          </Link>
        </div>

        <p className="footer-copy">
          © 2025 LAWVS National Legal Awards
          <br />
          Powered by LAWVS Legal India Pvt. Ltd.
        </p>
      </div>
    </footer>
  );
}
